import { Component, ElementRef, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core'
import { FormGroupDirective, NgControl } from '@angular/forms'

@Component({
    selector: 'superflex-autocompleted',
    template: `
        <label for="controltext"> {{label}} <span *ngIf="ngControl.control.errors?.required" style="font-weight: 900;">*</span> </label>
        <p-autoComplete
                [readonly]="readonly"
                [formControl]='ngControl.control'
                [suggestions]="suggestions"
                (completeMethod)="autocompleteMethod($event)"
                (onBlur)='cleanAutocompletd()'
                field="field"
                [dropdown]="dropdown"
                [multiple]="multiple"
                [forceSelection]="true"
                [minLength]="1">
            </p-autoComplete>
        <small *ngIf="readonly" style="color: #9e9e9e;" >Read Only</small>
        <app-error [input]="ngControl.control" [form]="form"></app-error>`,
    host: { 'class': 'p-field' }
})
export class AutocompletedComponent implements OnInit {

    @Input() suggestions: any[]

    @Output() onAutoCompleted: EventEmitter<any> = new EventEmitter()

    @Input() isDisabled: boolean = false
    @Input() readonly: boolean = false
    @Input() dropdown: boolean = false
    @Input() multiple: boolean = false
    @Input() label: string = ''

    @Input() placeholder = '';
    @ViewChild('rb') inputViewChild: ElementRef;

    @Output() onFocus: EventEmitter<any> = new EventEmitter();
    @Output() onBlur: EventEmitter<any> = new EventEmitter();

    public checked: boolean;
    public focused: boolean;

    form!: FormGroupDirective;

    constructor(@Self() @Optional() public ngControl: NgControl, private rootFormGroup: FormGroupDirective) {
        this.form = this.rootFormGroup;
        if (this.ngControl) {
            ngControl.valueAccessor = this
        }
    }

    public onModelTouched = () => {/** */ };

    ngOnInit(): void {
        //
    }

    writeValue(value: any): void {/**/ }
    registerOnChange(fn: any): void {/** */}
    registerOnTouched(fn: any): void {/** */}
    setDisabledState?(isDisabled: boolean): void {/** */}

    autocompleteMethod(event) {
        let query = event.query
        this.onAutoCompleted.emit(query)
    }

    cleanAutocompletd(){
        if(this.ngControl.control.invalid)
            this.ngControl.control.setValue(null)
    }

    onInputFocus(event): void {
        this.focused = true;
        this.onFocus.emit(event);
    }

    onInputBlur(event): void {
        this.focused = false;
        this.onModelTouched();
        this.onBlur.emit(event);
    }

    focus(): void {
        this.inputViewChild.nativeElement.focus();
    }

    ngOnDestroy(): void {
        // this.registry.remove(this);
    }


}
